import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";

export default function LobbyDeleteDialog(props) {
  const onSuccess = () => {
    props.onSuccessHandler(props.lobby);
  };
  const onCancel = () => {
    props.onClose();
  };
  return (
    <Dialog
      open={Boolean(props.lobby)}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          minHeight: 180,
          padding: 2,
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ textAlign: "center", fontWeight: 600 }}
      >
        Delete Lobby
      </DialogTitle>

      <DialogContent>
        <Box textAlign="center" mt={1}>
          <Typography variant="body1">
            Are you sure you want to delete this Lobby?
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "flex-end", px: 3, pb: 2 }}>
        <Button onClick={onCancel} variant="outlined">
          Cancel
        </Button>

        <Button
          onClick={onSuccess}
          color="error"
          variant="contained"
          disabled={props.isLoading}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
